import React from 'react';
import {useAppData} from "../../context/AppDataContext";
import {axiosInstance} from "../axios";
import {API} from "../../config/Config";

const ColumnSettings = ({gridId, columns, onColumnsChange}) => {
    const {setError, setSuccess} = useAppData();

    const handleColumnToggle = async (columnKey) => {
        const updatedColumns = columns.map(column =>
            column.key === columnKey
                ? {...column, visible: !column.visible}
                : column
        );

        try {
            // Uložení na server
            const {method, url} = API.saveUserGridSettings;
            await axiosInstance[method](url, {
                [gridId]: {
                    columns: updatedColumns
                }
            });

            // Aktualizace lokálního stavu
            onColumnsChange?.(updatedColumns);
            setSuccess("Nastavení sloupců bylo úspěšně uloženo");
        } catch (error) {
            setError("Nepodařilo se uložit nastavení sloupců");
        }
    };

    return {
        label: "Nastavení sloupců",
        items: columns?.map(column => ({
            label: column.label,
            checked: column.visible,
            onClick: () => handleColumnToggle(column.key)
        }))
    };
};

export default ColumnSettings;